import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { app } from '@/firebase'
import Normalize from 'normalize.css'

Vue.config.productionTip = false

let vueApp

app.auth().onAuthStateChanged(function(user) {
  if (!vueApp) {
    vueApp = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})